import AuthConstants from '../../auth/models/AuthConstants';
const { RENEW_ACCESS_TOKEN, RENEW_ACCESS_TOKEN_SUCCESS, RENEW_ACCESS_TOKEN_FAILURE, GET_TOKENS_SUCCESS, GET_TOKENS_FAILURE, GET_TOKENS, CLEAR_TOKENS, SET_USER_SESSION_EXPIRED, SET_USER_SESSION_ABOUT_TO_EXPIRE, LOGOUT_USER, LOGOUT_USER_SUCCESS, LOGOUT_USER_FAILURE, GET_GOOGLE_SPOT_TOKENS, GET_GOOGLE_SPOT_TOKENS_SUCCESS, GET_GOOGLE_SPOT_TOKENS_FAILURE, SIGN_IN_FAILURE, } = AuthConstants;
const initialState = {
    response: undefined,
    error: false,
    tokenRetrievalFailed: false,
    userSessionExpired: false,
    userSessionAboutToExpire: false,
    isUserLoggedOut: false,
    isValidAccessToken: false,
    isLoading: false,
    signInFailed: false,
};
const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TOKENS:
        case GET_GOOGLE_SPOT_TOKENS: {
            return {
                ...state,
                isLoading: action?.payload?.showLoader ?? false,
                response: undefined,
                isUserLoggedOut: false,
                userSessionExpired: false,
                tokenRetrievalFailed: false,
                error: false,
                signInFailed: false,
            };
        }
        case RENEW_ACCESS_TOKEN: {
            return {
                ...state,
                response: {
                    ...state.response,
                    accessToken: undefined,
                    expiresIn: undefined,
                },
                isLoading: false,
                isUserLoggedOut: false,
                userSessionExpired: false,
                tokenRetrievalFailed: false,
                error: false,
                signInFailed: false,
            };
        }
        case GET_TOKENS_SUCCESS:
        case RENEW_ACCESS_TOKEN_SUCCESS:
        case GET_GOOGLE_SPOT_TOKENS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                response: action?.value?.response,
                error: false,
                isUserLoggedOut: false,
                signInFailed: false,
            };
        case GET_TOKENS_FAILURE:
        case GET_GOOGLE_SPOT_TOKENS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: true,
                tokenRetrievalFailed: true,
            };
        case RENEW_ACCESS_TOKEN_FAILURE:
            return {
                ...state,
                error: true,
                tokenRetrievalFailed: true,
                userSessionExpired: true,
            };
        case CLEAR_TOKENS: {
            return {
                ...state,
                response: undefined,
                error: false,
            };
        }
        case SIGN_IN_FAILURE: {
            return {
                ...state,
                signInFailed: true,
                response: undefined,
            };
        }
        case SET_USER_SESSION_EXPIRED:
            return {
                ...state,
                userSessionExpired: action?.value,
            };
        case SET_USER_SESSION_ABOUT_TO_EXPIRE:
            return {
                ...state,
                userSessionAboutToExpire: action?.value,
            };
        case LOGOUT_USER:
            return {
                ...state,
                isLoading: true,
                error: false,
                isUserLoggedOut: false,
            };
        case LOGOUT_USER_SUCCESS:
            return {
                ...state,
                response: undefined,
                isUserLoggedOut: true,
                isLoading: false,
            };
        case LOGOUT_USER_FAILURE:
            return {
                ...state,
                isUserLoggedOut: false,
                error: true,
                isLoading: false,
            };
        default:
            return state;
    }
};
export default authReducer;
